import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { NavLink } from '@classes/nav-link';
import { NavService } from '@services/nav.service';
import { FileService } from '@services/file.service';
import { FileConfig } from '@classes/file/file-config';
import { UiService } from '@services/ui.service';
import { FileDetail } from '@classes/file/file-detail';
import { UserService } from '@services/user.service';
import { FileSource } from '@enums/file-source.enum';
import { FileTypeCode } from '@enums/file-type-code.enum';

@Component({
    selector: 'app-simulation-files',
    templateUrl: './simulation-files.component.html',
    styleUrls: ['./simulation-files.component.scss']
})
export class SimulationFilesComponent implements OnInit, OnDestroy {
    private loadingSub: Subscription;

    config: FileConfig;
    importedFiles: FileDetail[];
    providerFiles: FileDetail[];
    backLink: NavLink;
    isLoading: boolean;

    constructor(
        private fileSrv: FileService,
        private navSrv: NavService,
        private uiSrv: UiService,
        private userSrv: UserService
    ) { }

    ngOnInit() {
        this.initSubscriptions();
        this.backLink = this.navSrv.getLinkFromRoute(['simulation', 'advanced'], 'arrow_back');
    }

    onSelectFile(file: FileDetail): void {
        this.userSrv.setFileSource(file, FileSource.simulation)
        .subscribe(() => {
            // Remove from list if already added, else add it
            if(this.config.selectedFileIds.indexOf(file.id) !== -1) {
                this.config.selectedFileIds = this.config.selectedFileIds
                    .filter(id => id !== file.id);
            } else {
                this.config.selectedFileIds.push(file.id);
            }
        });
    }

    private initSubscriptions(): void {
        this.isLoading = true;
        this.fileSrv.getSimulationFiles()
        .subscribe(filesConfig => {
            this.config = filesConfig;
            this.importedFiles = this.config.files.filter(f => f.source.code === FileTypeCode.imported);
            this.providerFiles = this.config.files.filter(f => f.source.code === FileTypeCode.provider);
            this.isLoading = false;
        });

        this.loadingSub = this.uiSrv.loadingStateChanged
        .subscribe(loadingState => {
            this.isLoading = loadingState;
        });
    }

    ngOnDestroy(): void {
        if(this.loadingSub) {
            this.loadingSub.unsubscribe();
        }
    }
}
